import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useHashScroll = (delay: number = 150) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      
      const scroll = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      const timer = setTimeout(scroll, delay);
      
      return () => clearTimeout(timer);
    }
  }, [hash, delay]);
};

export default useHashScroll;
